type Props = {
  text: string;
  clazz?: string;
  cssStyles?: string;
  /** Use `span` when the title sits inside a button (e.g. collapsible trigger). Default `h3`. */
  as?: "h3" | "span";
};

function SectionTitle({
  text,
  clazz = "text-xl md:text-2xl",
  cssStyles = "",
  as: Comp = "h3",
}: Props) {
  return (
    <Comp className={`font-sans font-medium ${clazz} text-slate-600 ${cssStyles}`}>
      {text}
    </Comp>
  );
}

export default SectionTitle;